import { Injectable } from "@angular/core";
import { Action } from "@ngrx/store";

import { SYNC_SUFFIX } from "../fetch-status/fetch-status.const";
import { ActionWithPayload } from "../model";

import { SetFetchedActionPayload } from "./state-cache.model";

const prefix = "[Store Cache]";

export const STORE_CACHE_TYPE = {
	setFetched: `${prefix} Set Fetched ${SYNC_SUFFIX}`,
	clearCache: `${prefix} Clear Cache ${SYNC_SUFFIX}`,
	clearAllCache: `${prefix} Clear All Cache ${SYNC_SUFFIX}`,
};

@Injectable({
	providedIn: "root",
})
export class StateCacheAction {
	clearCache(cacheKey: string): ActionWithPayload<string> {
		return {
			type: STORE_CACHE_TYPE.clearCache,
			payload: cacheKey,
		};
	}

	clearAllCache(): Action {
		return { type: STORE_CACHE_TYPE.clearAllCache };
	}

	setFetched(cacheKey: string, isServer: boolean): ActionWithPayload<SetFetchedActionPayload> {
		return {
			type: STORE_CACHE_TYPE.setFetched,
			payload: { cacheKey, isServer },
		};
	}
}
